var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.html)?_c('article',{staticClass:"hub-rules",domProps:{"innerHTML":_vm._s(_vm.html)}}):_c('HubContentMessage',{attrs:{"text":_vm.$t('global.noData')}})
}
var staticRenderFns = []

export { render, staticRenderFns }